import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";
import VariableMapping from "../../../FlowConfigurationInputs/VariableMapping/VariableMapping";
import Button from "@material-ui/core/Button/Button";
import AssignTable from "./AssignTable";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddIcon from '@material-ui/icons/AddCircleOutline';

// style tabpanel
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function Assign({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.DICTIONARY.ASSIGN.";
  const [value, setValue] = useState(0);
  const [value2, setValue2] = useState(0);
  const [openVariableMapping, setOpenVariableMapping] = useState(false);
  const [mappingData, setMappingData] = useState([]);
  const [openDictionaryTable, setOpenDictionaryTable] = useState(false);
  const [dictionaryTable, setDictionaryTable] = useState([]);
  const [index, setIndex] = useState(-1);

  // set value to initial field  
  useEffect(() => {
    if (!action.fields.destinationVariable) {
      action.fields.destinationVariable = { value: [] };
    } else {
      if (Array.isArray(action.fields.destinationVariable.value)) {
        setValue2(0);
      } else {
        setValue2(1);
      }
      setMappingData(action.fields.destinationVariable.value);
    }
    if (!action.fields.sourceVariable) {
      action.fields.sourceVariable = { value: [] };
    } else {
      if (Array.isArray(action.fields.sourceVariable.value)) {
        setValue(0);
      } else {
        setValue(1);
      }
      setDictionaryTable(action.fields.sourceVariable.value);
    }
  }, [action, variables]);

  // changed tabs panel  1
  function handleChangeTabs(newValue) {
    setValue(newValue);
    // set value
    if (newValue === 1) {
      action.fields.sourceVariable.value = "";
      setDictionaryTable([]);
    }
    // selected map to variable
    else {
      action.fields.sourceVariable.value = [];
      delete action.fields.sourceVariable.htmlValue;
    }
  }
  // changed tabs panel  2
  function handleChangeTabs2(newValue) {
    setValue2(newValue);
    // set value
    if (newValue === 1) {
      action.fields.destinationVariable.value = "";
      setMappingData([]);
    }
    // selected map to variable
    else {
      action.fields.destinationVariable.value = [];
      delete action.fields.destinationVariable.htmlValue;
    }
  }
  // We pass the value when there is a change.
  useEffect(() => {
    action.fields.destinationVariable.value = mappingData;
  }, [action.fields?.destinationVariable, mappingData]);

  useEffect(() => {
    action.fields.sourceVariable.value = dictionaryTable;
  }, [action.fields?.sourceVariable, dictionaryTable]);

  //open edit page
  function handleOpenEdit(indx, setState) {
    setIndex(indx);
    setState(true)
  }
  return (
    <div>
      <div className="form-element">
        {t(label + "SELECT-SOURCE-VARIABLE")}

        <div className="condition-tabs">
          <button
            className={value === 0 ? 'condition-active' : ''}
            onClick={() => handleChangeTabs(0)}>
            {t(label + "DICTIONARY")}
          </button>
          <button
            className={value === 1 ? 'condition-active' : ''}
            onClick={() => handleChangeTabs(1)}>
            {t(label + "VARIABLE")}
          </button>
        </div>

        <TabPanel value={value} index={0}>
          <div className="form-element">
            <table>
              <thead>
                <tr>
                  <th>{t(label + "TYPE")}</th>
                  <th>{t(label + "KEY")}</th>
                  <th>{t(label + "VALUE")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(dictionaryTable) &&
                  dictionaryTable.map((item, indx) => (
                    <tr key={indx}>
                      <td>{item.type}</td>
                      <td>{item.key}</td>
                      <td>{item.value}</td>
                      <td onClick={() => handleOpenEdit(indx, setOpenDictionaryTable)}>
                        <EditOutlinedIcon />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="form-element">
            <Button onClick={() => setOpenDictionaryTable(true)}
              style={{ border: "none", color: "#8F94A6", fontWeight: 700, textTransform: "none" }}>
              {t(label + "ADD")}
              <AddIcon style={{ paddingLeft: 5 }} onClick={() => setOpenDictionaryTable(true)} />
            </Button>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TextInput
            action={action}
            inputName="sourceVariable"
            isRequired={false}
            setOpenVariable={setOpenVariable}
            variables={variables}
          />
        </TabPanel>
      </div>

      <div className="form-element">
        {t(label + "SELECT-DESTINATION-VARIABLE")}
        <div className="condition-tabs">
          <button
            className={value2 === 0 ? 'condition-active' : ''}
            onClick={() => handleChangeTabs2(0)}>
            {t(label + "MULTIPLE-VARIABLES")}
          </button>
          <button
            className={value2 === 1 ? 'condition-active' : ''}
            onClick={() => handleChangeTabs2(1)}>
            {t(label + "DICTIONARY")}
          </button>
        </div>

        <TabPanel value={value2} index={0}>
          <div className="form-element">
            <table>
              <thead>
                <tr>
                  <th>{t(label + "KEY")}</th>
                  <th>{t(label + "MAP-VARIABLE")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(mappingData) &&
                  mappingData?.map((item, indx) => (
                    <tr key={index}>
                      <td>{item.key}</td>
                      <td>{item.toVariable}</td>
                      <td onClick={() => handleOpenEdit(indx, setOpenVariableMapping)}>
                        <EditOutlinedIcon />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="form-element">
            <Button onClick={() => setOpenVariableMapping(true)}
              style={{ border: "none", color: "#8F94A6", fontWeight: 700, textTransform: "none" }}>
              {t(label + "ADD-VARIABLE-MAP")}
              <AddIcon style={{ paddingLeft: 5 }} onClick={() => setOpenVariableMapping(true)} />
            </Button>
          </div>
        </TabPanel>
        <TabPanel value={value2} index={1}>
          <VariablePicker
            action={action}
            inputName="destinationVariable"
            variables={variables}
            setOpenVariable={setOpenVariable}
            filter="dictionary"
            isRequired
          />
          <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'dictionary' })}</em></small>
        </TabPanel>
      </div>
     
      {openVariableMapping && (
        <VariableMapping
          setOpen={setOpenVariableMapping}
          setOpenVariable={setOpenVariable}
          inputName="destinationVariable"
          action={action}
          variables={variables}
          setMappingData={setMappingData}
          mappingData={mappingData}
          index={index}
          setIndex={setIndex}
        />
      )}
      {openDictionaryTable && (
        <AssignTable
          index={index}
          setOpen={setOpenDictionaryTable}
          setOpenVariable={setOpenVariable}
          inputName="sourceVariable"
          action={action}
          variables={variables}
          setDictionaryTable={setDictionaryTable}
          dictionaryTable={dictionaryTable}
          setIndex={setIndex}
        />
      )}
    </div>
  );
}

export default Assign;
